import { ProductWithImage } from 'shared/src/api/types'

export const makeSampleProduct = (
  productName: string,
  brandName: string,
  image: string
): ProductWithImage => ({
  id: 0,
  brandId: 0,
  brandName,
  category: null,
  name: productName,
  url: '',
  originalUrl: null,
  resolvedUrl: null,
  imageId: 0,
  price: null,
  saves: 0,
  createdAt: new Date(),
  updatedAt: new Date(),
  image: {
    lowres: image,
    full: image,
    thumbnail: image,
    altText: '',
  },
  views: 0,
  outgoingClicks: 0,
  matchesSearch: false,
})
